import React from 'react';
import { Typography, Box, Link } from '@mui/material';

export default function ComplianceDashboard() {

return (
    <>
        <Box sx={{display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',}}>
            <Typography zIndex={'1'}>
            Compliances: <Link href='./cisOverview' underline="none">CIS Compliance </Link> 
                        | <Link href='./pciOverview' underline="none">PCI Compliance </Link>
                        | <Link href='./nistOverview' underline="none">NIST 800-53 </Link>  
                        | <Link href='./mitreAttack' underline="none">MITRE ATT&CK </Link> 
                        | <Link href='./socOverview' underline="none">SOC-2/TSC </Link>
                        | <Link href='./hipaaOverview' underline="none">HIPAA </Link>
            </Typography>
        </Box>  
    </>
)
}